<template>
  <el-card class="m-b">
    <div slot="header" class="clearfix">
      <span class="saas-card-header-name">收货信息</span>
    </div>
    <div class="order-content-detail">
      <el-form
        :model="consigneeInfo"
        label-position="right"
        label-width="150px"
        :gutter="20"
        disabled
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收货人：" prop="consignee">
              <el-input v-model="consigneeInfo.consignee"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="consigneePhone">
              <el-input v-model="consigneeInfo.consigneePhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="交货地址：" prop="address">
              <el-input v-model="consigneeInfo.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交货时间：" prop="receiveTime">
              <el-date-picker
                class="w100"
                v-model="consigneeInfo.receiveTime"
                type="datetime"
                placeholder="交货时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    secondInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      consigneeInfo: this.secondInfo
    }
  }
}
</script>
